
import { Checkbox } from '@mui/material';
import Swal from 'sweetalert2';
import Model from '../models/model';
import strings from '../Globalization/index'
import consts from '../consts';
import util from '../util';
import connection from '../services/Connection';

const { getRoles } = consts;
/**
 * @dsec UUId is not handel ad backend so its commited out once its handeled so uncomment it
 * And other field are comment becuase the array of obj funcationailty is not written once its written uncomment it 
 */

const huluAdminOnly = Object.keys(getRoles()).filter((role) => role.toLowerCase() === "huluadmin")

const readOnly = () => {
	const currentRole = util.localData?.loginData?.roles[0];
	return !huluAdminOnly.includes(currentRole)
};

const CheckBox = ({ row, colDef }) => {

	const handleCheck = async () => {
		Swal.fire({
			title: strings.SaveConfarmation,
			showDenyButton: true,
			confirmButtonText: strings.Ok,
			icon: 'info',
			denyButtonText: strings.Cancel,
			allowOutsideClick: false
		}).then((result) => {
			if (result.isConfirmed) {
				handelSaveData();
			} else if (result.isDenied) {
				Swal.fire({
					title: strings.DenyConfarmation,
					icon: 'info',
					allowOutsideClick: false
				})
			}
		})
	}
	const handelSaveData = async () => {
		const formData = new FormData();
		formData.append('action', 'update');
		formData.append('id', row?.id);
		formData.append('Published', !row?.Published)
		const response = await fetch(connection.HuluScopeRegion, {
			method: 'POST',
			credentials: 'include',
			body: formData
		})
		const jsonResponse = await response.json();
		const swalTitle = jsonResponse?.success ? strings.SavedData : strings.Error;
		Swal.fire({
			title: swalTitle,
			text: strings[jsonResponse.info],
			icon: "success",
			confirmButtonText: strings.Ok,
			allowOutsideClick: false
		})
		colDef.refreshData();
	}

	return (
		<Checkbox
			disabled={readOnly()}
			checked={row?.Published}
			onClick={handleCheck}
			color="primary"
			inputProps={{ 'aria-label': 'checkbox' }}
		/>)
}

const model = new Model({
	name: 'HuluScopeRegion',
	idProperty: "id",
	allowDelete: false,
	allowImport: false,
	disableDelete: true,
	disableAdd: true,
	disableExport: true,
	disableFiltering: true,
	hideGridFooter: true,
	readOnly: readOnly,
	showGridRefreshBtn: true,
	formTitleField: 'Scope Regions',
	pageSize: 10,
	formGroups: [{
		fields: ["Active", "CreatedOn", "ModifiedOn", "Status", "displayOrder", "regionId"]
	}],
	gridTitle: 'Regions',
	columns: [
		{ header: 'ManufacturerName', field: 'ManufacturerName', width: 120 },
		{ header: 'ScopeModel', field: 'ScopeModel', width: 120 },
		{ header: 'scopeType', field: 'ScopeType', width: 120 },
		{ header: 'RegionNameNew', field: 'RegionName', width: 120 },
		{ field: 'Published', width: 120, type: "boolean", renderCell: CheckBox, readOnly: readOnly, },
	]
});
export const RegionModel = model;
export default model.createFormBase();